import { TitleCardsList } from "Components/SelectableCard/Title";
import { Flex, Typography } from "antd";

const testStatusOptions = [
  {
    title: "Expected Score",
  },
  {
    title: "Test Completed",
  },
];

export const TestStatus = ({ selectedCard, setSelectedCard }) => {
  const { Title } = Typography;
  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Title style={{ fontSize: "18px" }}>Test status</Title>
      <Flex wrap>
        <TitleCardsList
          options={testStatusOptions}
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />
      </Flex>
    </Flex>
  );
};
